(function () {
  'use strict';

  var TOTAL_CLICKS  = 8;
  var DISCOUNT_CODE = 'NORDWALD10';

  var CRACKS = [
    { x:50, y:48, len:78, ang:32  },
    { x:28, y:28, len:58, ang:-44 },
    { x:58, y:62, len:70, ang:14  },
    { x:38, y:72, len:52, ang:-22 },
    { x:68, y:22, len:54, ang:62  },
    { x:18, y:54, len:48, ang:28  },
    { x:54, y:82, len:64, ang:-52 },
    { x:74, y:48, len:42, ang:-18 },
  ];

  /* ── Audio ── */
  var AC = null;

  function ensureAC() {
    if (!AC) {
      try { AC = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { AC = null; }
    }
    if (AC && AC.state === 'suspended') { try { AC.resume(); } catch (e) {} }
  }

  function playTick(vol) {
    if (!AC) return;
    try {
      var osc = AC.createOscillator();
      var gain = AC.createGain();
      osc.connect(gain); gain.connect(AC.destination);
      osc.type = 'sine';
      osc.frequency.setValueAtTime(880 + Math.random() * 220, AC.currentTime);
      osc.frequency.exponentialRampToValueAtTime(440, AC.currentTime + 0.06);
      gain.gain.setValueAtTime(vol || 0.12, AC.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.0001, AC.currentTime + 0.08);
      osc.start(AC.currentTime);
      osc.stop(AC.currentTime + 0.09);
    } catch (e) {}
  }

  function playCrack(vol) {
    if (!AC) return;
    try {
      var bufLen = AC.sampleRate * 0.12;
      var buf = AC.createBuffer(1, bufLen, AC.sampleRate);
      var data = buf.getChannelData(0);
      for (var i = 0; i < bufLen; i++) {
        data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / bufLen, 2.5);
      }
      var src = AC.createBufferSource();
      src.buffer = buf;
      var gain = AC.createGain();
      var filt = AC.createBiquadFilter();
      filt.type = 'bandpass';
      filt.frequency.value = 2800;
      filt.Q.value = 0.8;
      src.connect(filt); filt.connect(gain); gain.connect(AC.destination);
      gain.gain.setValueAtTime(vol || 0.25, AC.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.0001, AC.currentTime + 0.13);
      src.start(AC.currentTime);
    } catch (e) {}
  }

  function playShatter() {
    if (!AC) return;
    try {
      var bufLen = AC.sampleRate * 0.55;
      var buf = AC.createBuffer(1, bufLen, AC.sampleRate);
      var data = buf.getChannelData(0);
      for (var i = 0; i < bufLen; i++) {
        var env = Math.pow(1 - i / bufLen, 1.8);
        data[i] = (Math.random() * 2 - 1) * env;
      }
      var src = AC.createBufferSource();
      src.buffer = buf;
      var gain = AC.createGain();
      var filt = AC.createBiquadFilter();
      filt.type = 'highpass';
      filt.frequency.value = 1200;
      src.connect(filt); filt.connect(gain); gain.connect(AC.destination);
      gain.gain.setValueAtTime(0.55, AC.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.0001, AC.currentTime + 0.55);
      src.start(AC.currentTime);
    } catch (e) {}
  }

  function playWin() {
    if (!AC) return;
    try {
      var notes = [523.25, 659.25, 783.99, 1046.50];
      notes.forEach(function (freq, i) {
        var osc = AC.createOscillator();
        var gain = AC.createGain();
        osc.connect(gain); gain.connect(AC.destination);
        osc.type = 'triangle';
        osc.frequency.value = freq;
        var t = AC.currentTime + i * 0.11;
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(0.22, t + 0.03);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.38);
        osc.start(t);
        osc.stop(t + 0.40);
      });
    } catch (e) {}
  }

  /* ── Shards ── */
  function spawnShards(rect) {
    var cx = rect.left + rect.width / 2;
    var cy = rect.top  + rect.height / 2;
    for (var i = 0; i < 14; i++) {
      var shard = document.createElement('div');
      shard.className = 'lgame-shard';
      var ang = (i / 14) * Math.PI * 2 + (Math.random() - 0.5) * 0.6;
      var dist = 55 + Math.random() * 70;
      var tx = Math.cos(ang) * dist;
      var ty = Math.sin(ang) * dist;
      var tr = (Math.random() - 0.5) * 540;
      shard.style.left = cx + 'px';
      shard.style.top  = cy + 'px';
      shard.style.setProperty('--tx', 'translateX(' + tx.toFixed(1) + 'px)');
      shard.style.setProperty('--ty', 'translateY(' + ty.toFixed(1) + 'px)');
      shard.style.setProperty('--tr', tr.toFixed(1) + 'deg');
      shard.style.animationDelay = (Math.random() * 0.04).toFixed(3) + 's';
      document.body.appendChild(shard);
      setTimeout(function (s) { if (s.parentNode) s.remove(); }, 820, shard);
    }
  }

  /* ── Gyro ── */
  function setupGyro(wrap, ice) {
    if (!window.DeviceOrientationEvent) return;
    var baseB = null, baseG = null;
    var cur = { x: 0, y: 0 };
    var target = { x: 0, y: 0 };
    var rafId = null;

    function tick() {
      cur.x += (target.x - cur.x) * 0.12;
      cur.y += (target.y - cur.y) * 0.12;
      ice.style.transform = 'rotateX(' + cur.x.toFixed(2) + 'deg) rotateY(' + cur.y.toFixed(2) + 'deg)';
      rafId = requestAnimationFrame(tick);
    }

    function onOrient(e) {
      if (baseB === null) { baseB = e.beta || 0; baseG = e.gamma || 0; }
      var db = ((e.beta  || 0) - baseB);
      var dg = ((e.gamma || 0) - baseG);
      target.x = Math.max(-18, Math.min(18, -db * 0.6));
      target.y = Math.max(-18, Math.min(18,  dg * 0.6));
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    function request() {
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        DeviceOrientationEvent.requestPermission().then(function (s) {
          if (s === 'granted') window.addEventListener('deviceorientation', onOrient);
        }).catch(function () {});
      } else {
        window.addEventListener('deviceorientation', onOrient);
      }
    }

    ice.addEventListener('click', function () { request(); }, { once: true });
  }

  /* ── Notification Pill ── */
  function buildNotif() {
    var notif = document.createElement('div');
    notif.className = 'lgame-notif';
    notif.id = 'lgame-notif';
    notif.innerHTML =
      '<span class="lgame-notif__crystal">💎</span>' +
      '<div class="lgame-notif__text">' +
        '<div class="lgame-notif__title">Geheimrabatt freischalten</div>' +
        '<div class="lgame-notif__sub">Tippe um den Jadekristall zu brechen</div>' +
      '</div>' +
      '<span class="lgame-notif__arrow">›</span>';
    document.body.appendChild(notif);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { notif.classList.add('show'); });
    });

    var timer = setTimeout(function () { dismissNotif(notif); }, 4200);

    notif.addEventListener('click', function () {
      clearTimeout(timer);
      dismissNotif(notif);
      setTimeout(buildMiniCard, 120);
    });
  }

  function dismissNotif(notif) {
    if (!notif || !notif.parentNode) return;
    notif.classList.remove('show');
    notif.classList.add('hide');
    setTimeout(function () { if (notif.parentNode) notif.remove(); }, 420);
  }

  /* ── Mini Card ── */
  function buildMiniCard() {
    var mini = document.createElement('div');
    mini.className = 'lgame-mini';
    mini.id = 'lgame-mini';

    var gameArea = document.createElement('div'); gameArea.id = 'lgame-area';

    var handle = document.createElement('div'); handle.className = 'lgame-mini__handle';
    var title  = document.createElement('div'); title.className  = 'lgame-mini__title'; title.textContent = 'Jadekristall';
    var sub    = document.createElement('div'); sub.className    = 'lgame-mini__sub';   sub.textContent   = 'Klicke den Kristall frei!';

    var gyroWrap = document.createElement('div'); gyroWrap.id = 'lgame-gyro-wrap';
    gyroWrap.style.cssText = 'margin:0 auto 14px;perspective:700px;display:flex;justify-content:center;transition:transform 0.10s ease-out;will-change:transform;';

    var ice = document.createElement('div'); ice.className = 'lgame-ice'; ice.id = 'lgame-ice';
    var rew = document.createElement('div'); rew.className = 'lgame-ice-reward';
    rew.innerHTML = '10%<small>RABATT</small>';
    ice.appendChild(rew);

    CRACKS.forEach(function (c, i) {
      var el = document.createElement('div'); el.className = 'lgame-crack';
      el.style.left  = c.x   + '%';
      el.style.top   = c.y   + '%';
      el.style.width = c.len + '%';
      el.style.transform = 'rotate(' + c.ang + 'deg)';
      el.dataset.crackIdx = i;
      ice.appendChild(el);
    });
    gyroWrap.appendChild(ice);

    var progWrap = document.createElement('div'); progWrap.className = 'lgame-progress-wrap';
    var progFill = document.createElement('div'); progFill.className = 'lgame-progress-fill'; progFill.id = 'lgame-fill';
    progWrap.appendChild(progFill);

    var hint = document.createElement('div'); hint.className = 'lgame-hint'; hint.id = 'lgame-hint';
    hint.textContent = '0 / ' + TOTAL_CLICKS + ' Klicks';

    gameArea.appendChild(handle);
    gameArea.appendChild(title);
    gameArea.appendChild(sub);
    gameArea.appendChild(gyroWrap);
    gameArea.appendChild(progWrap);
    gameArea.appendChild(hint);

    /* Reward area */
    var rewardArea = document.createElement('div'); rewardArea.className = 'lgame-reward'; rewardArea.id = 'lgame-reward';
    var rbadge = document.createElement('div'); rbadge.className = 'lgame-reward-badge'; rbadge.textContent = '✓ Freigeschaltet';
    var rpct   = document.createElement('div'); rpct.className   = 'lgame-reward-pct';   rpct.textContent   = '10%';
    var rlbl   = document.createElement('div'); rlbl.className   = 'lgame-reward-label'; rlbl.textContent   = 'Rabatt auf deine Bestellung';
    var codeBox = document.createElement('div'); codeBox.className = 'lgame-code-box';
    var codeTxt = document.createElement('span'); codeTxt.className = 'lgame-code-text'; codeTxt.textContent = DISCOUNT_CODE;
    var copyBtn = document.createElement('button'); copyBtn.className = 'lgame-copy-btn'; copyBtn.textContent = 'Kopieren';
    copyBtn.addEventListener('click', function () {
      try { navigator.clipboard.writeText(DISCOUNT_CODE); } catch (err) {
        var t = document.createElement('textarea'); t.value = DISCOUNT_CODE;
        document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove();
      }
      copyBtn.textContent = '✓ Kopiert!'; copyBtn.classList.add('copied');
    });
    codeBox.appendChild(codeTxt); codeBox.appendChild(copyBtn);
    rewardArea.appendChild(rbadge);
    rewardArea.appendChild(rpct);
    rewardArea.appendChild(rlbl);
    rewardArea.appendChild(codeBox);

    var dismiss = document.createElement('button');
    dismiss.className = 'lgame-dismiss'; dismiss.textContent = 'Schlie\xDFen';
    dismiss.addEventListener('click', function () { closeMini(mini); });

    mini.appendChild(gameArea); mini.appendChild(rewardArea); mini.appendChild(dismiss);
    document.body.appendChild(mini);

    setupGyro(gyroWrap, ice);

    requestAnimationFrame(function () { requestAnimationFrame(function () { mini.classList.add('show'); }); });

    /* Game logic */
    var clicks = 0, done = false;

    ice.addEventListener('click', function (e) {
      if (done) return;
      ensureAC();
      clicks++;
      var pct = Math.min(clicks / TOTAL_CLICKS, 1);

      var rect = ice.getBoundingClientRect();
      var rip = document.createElement('div'); rip.className = 'lgame-ice-ripple';
      rip.style.left = ((e.clientX - rect.left)  / rect.width  * 100).toFixed(1) + '%';
      rip.style.top  = ((e.clientY - rect.top)   / rect.height * 100).toFixed(1) + '%';
      ice.appendChild(rip);
      setTimeout(function () { rip.remove(); }, 550);

      progFill.style.width = (pct * 100) + '%';
      hint.textContent = clicks + ' / ' + TOTAL_CLICKS + ' Klicks';

      var cracksToShow = Math.floor(pct * CRACKS.length);
      ice.querySelectorAll('.lgame-crack').forEach(function (el) {
        if (parseInt(el.dataset.crackIdx) < cracksToShow) el.classList.add('show');
      });

      ice.classList.remove('shaking'); void ice.offsetWidth; ice.classList.add('shaking');

      if (clicks % 5 === 0) {
        playCrack(0.16 + pct * 0.28);
        ice.classList.remove('stage-flash'); void ice.offsetWidth; ice.classList.add('stage-flash');
      } else {
        playTick(0.09 + pct * 0.07);
      }

      if (clicks >= TOTAL_CLICKS) {
        done = true; playShatter();
        var r = ice.getBoundingClientRect(); spawnShards(r);
        ice.style.transition = 'transform 0.28s,opacity 0.28s';
        ice.style.transform  = 'scale(1.12)';
        ice.style.opacity    = '0';
        setTimeout(function () {
          playWin();
          gameArea.style.display = 'none';
          rewardArea.classList.add('show');
          sessionStorage.setItem('lgame-done', '1');
        }, 300);
      }
    });
  }

  function closeMini(mini) {
    if (!mini || !mini.parentNode) return;
    mini.classList.remove('show'); mini.classList.add('hide');
    sessionStorage.setItem('lgame-done', '1');
    setTimeout(function () { if (mini.parentNode) mini.remove(); }, 380);
  }

  /* ── Widget API ── */
  window.lgameOpen = function() {
    if (document.getElementById('lgame-mini')) return;
    buildMiniCard();
  };
  window.addEventListener('fifteen-crystal-tap', function() {
    if (document.getElementById('lgame-mini')) return;
    buildMiniCard();
  });

  /* ── Init ── */
  function init() {
    if (sessionStorage.getItem('lgame-done')) return;
    setTimeout(buildNotif, 5500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
